import { DefaultComparator } from './comparators/default-comparator';
import {
  IFilterComparator,
  FilterOptions,
  FilterPassParams
} from '../filter-types';
import { convertToStringArray } from '../filter-utils';
import { FilterResultFacade } from '../filter-result-facade';
import {
  CalendarGridColumnLabel,
  CalendarGridColumnName
} from '../../../grid/types/column.types';
import { FilterHandlerBase } from './base/filter-handler-base';
import { parityPlusGetter } from '../../../grid/utils/value-getters/parity-plus-getter';

export class ParityPlusFilterHandler extends FilterHandlerBase {
  private comparator: IFilterComparator<any>;

  get name(): string {
    return CalendarGridColumnName.ParityPlus;
  }

  get label(): string {
    return CalendarGridColumnLabel.ParityPlus;
  }
  get isInclusiveExclusive(): boolean {
    return false;
  }
  getFilterOptions(filterOptions: FilterOptions): any {
    return convertToStringArray(filterOptions.parityPlus);
  }

  hasValidDiff(options: FilterOptions, grid: any, store: any): boolean {
    return this.getValidDiffComparator(options).hasValidDiff(grid, store);
  }

  getValidDiffComparator(options): IFilterComparator<any> {
    if (!this.comparator) {
      this.comparator = new DefaultComparator();
    }
    this.comparator.applyFilterOptions(this.getFilterOptions(options));
    return this.comparator;
  }

  doFilterPass(params: FilterPassParams, result: FilterResultFacade) {
    const parityPlusFilter = params.filters[this.name];
    const { id: dealId, parityPlus } = params.deal;

    const parityPlusValue = parityPlusGetter({
      data: {
        parityPlus
      }
    });

    const parityPlusFilterPassed =
      parityPlusFilter !== null
        ? parityPlusValue.indexOf(parityPlusFilter.model.value) !== -1
        : true;

    result.applyDealFilerResult(dealId, this.name, parityPlusFilterPassed);

    return parityPlusFilterPassed;
  }
}
